import * as z from "zod"
import { WorkspaceRole } from "@prisma/client"

export const WorkspaceAccessDbModel = z.object({
  workspaceId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  userId: z.string(),
  role: z.nativeEnum(WorkspaceRole),
})
